import { Button } from 'components/Button';
import { Money } from 'components/Money';
import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './StoreCheckoutStickyBar.scss';
/**
 * @component StoreCheckoutStickyBar
 * @since 1.0.0
 */
export function StoreCheckoutStickyBar(props) {
    const { deal, submitLabel, showLockIcon = false, disabled } = props;
    return (React.createElement("div", { className: classNames('store-checkout-sticky-bar', props.className) },
        (deal === null || deal === void 0 ? void 0 : deal.total) != null && (React.createElement("div", { className: "store-checkout-sticky-bar__total" },
            React.createElement("span", { className: "store-checkout-sticky-bar__total-label" }, t('Total')),
            React.createElement(Money, { value: deal.total, className: "store-checkout-sticky-bar__total-amount" }))),
        React.createElement("div", { className: "store-checkout-sticky-bar__action" },
            React.createElement(Button, { style: "primary", size: "large", className: "store-checkout-sticky-bar__submit", picto: showLockIcon ? 'lock' : undefined, label: submitLabel, disabled: disabled, submit: true }),
            showLockIcon && (React.createElement("span", { className: "store-checkout-sticky-bar__secure" }, t('Secure payment'))))));
}
